import { Thunk } from '../../../types/reduxTypes';
import { closePopup, openPopup } from '../../popupPanel/popupActions';
import { PopupIds } from '../../popupPanel/popupConstants';
import { activePopupDataSelector } from '../../popupPanel/popupOpenSelector';
import { TiptapSelectionPopupData } from './tiptapSelectionPopupTypes';

export const openTiptapSelectionPopup =
    (data: TiptapSelectionPopupData): Thunk =>
        (dispatch) => {
            dispatch(closePopup('', true));
            dispatch(openPopup({ popupId: PopupIds.TIPTAP_SELECTION, data }));
        };

export const closeTiptapSelectionPopup = () => closePopup(PopupIds.TIPTAP_SELECTION, false);

export const tiptapSelectionPopupDataSelector = (state: unknown): TiptapSelectionPopupData | undefined =>
    activePopupDataSelector(state, { popupId: PopupIds.TIPTAP_SELECTION });
